import React, { ReactNode } from 'react';
import { Typography } from '@material-ui/core';

export type UserMenuTypes = null | 'assignmentDashboard' | 'groups' | 'classAndMethods';

export const getContent = (type: UserMenuTypes) => {
  let content: NonNullable<ReactNode> = <></>;
  switch (type) {
    case 'assignmentDashboard':
      content = assignmentDashboardTooltipContent;
      break;
    case 'groups':
      content = groupTooltipContent;
      break;
    case 'classAndMethods':
      content = classAndMethodsTooltipContent;
      break;
    default:
      break;
  }
  return content;
};

export const assignmentDashboardTooltipContent: NonNullable<React.ReactNode> = (
  <>
    <Typography variant="subtitle2" style={{ fontWeight: 700 }}>
      Geef lessen en oefeningenreeksen als taak
    </Typography>
    <Typography variant="subtitle2">
      Laat leerlingen zelfstandig werken aan taken die jij aanmaakt (met een deadline). Ze
      verschijnen op het startscherm van de leerlingen.
    </Typography>
  </>
);

export const groupTooltipContent: NonNullable<React.ReactNode> = (
  <>
    <Typography variant="subtitle2" style={{ fontWeight: 700 }}>
      Deel leerlingen in zoals jij dat wil
    </Typography>
    <Typography variant="subtitle2">
      Maak (differentiatie)groepen binnen klassen of over klassen heen.
    </Typography>
  </>
);

export const classAndMethodsTooltipContent: NonNullable<React.ReactNode> = (
  <>
    <Typography variant="subtitle2" style={{ fontWeight: 700 }}>
      Beheer welke klas met welke methode werkt
    </Typography>
    <Typography variant="subtitle2">
      Jij bepaalt welke leerling, welke methode te zien krijgt.
    </Typography>
  </>
);
